module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "scroll-container",
    style: ({
      'max-height': _vm.height
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3fa561e2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scroll.vue
// module id = 1013
// module chunks = 0